import { LabelValues } from 'Modules'

export const deepClone = (data: any) => {
  try {
    return JSON.parse(JSON.stringify(data))
  } catch {
    return {}
  }
}

export function isNotNullish<T>(value: T | null | undefined): value is T {
  return value != null
}

export const convertObjectToLabelValue = (data: {
  obj: any
  fieldValue?: string
  fieldLabel?: string
  label?: any
}): LabelValues | null => {
  if (!data) return null
  const { obj: input, fieldLabel, fieldValue, label } = data
  return {
    ...input,
    value: input[fieldValue ?? '_id'],
    label: label ?? input[fieldLabel ?? 'label'],
  } as LabelValues
}

export const getObjectToValue = (data: LabelValues[], value: any, field = 'value') => {
  return data?.length ? data.find((c) => c[`${field}`] === value) || null : null
}

export const getLabelToValue = (data: LabelValues[], value: any, field = 'value') => {
  const input = getObjectToValue(data, value, field)
  return input ? input?.label || '' : ''
}
